import { TextParagraph } from 'theme/components/text'

export function Footer() {
  return (
    <footer className="w-full border-t border-t-[#E6E8EC] pt-[14px] pb-3">
      <div className="flex items-center justify-between px-4 xl:px-[144px]">
        <TextParagraph size="xs" variant="light7">
          © 2025 - World Swap
        </TextParagraph>

        <TextParagraph size="xs" variant="light7">
          Privacy Policy
        </TextParagraph>
      </div>
    </footer>
  )
}
